import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonContent, MenuController, ModalController, NavController } from '@ionic/angular';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ThemeService } from '../_core/services/theme.service';
import { AuthService } from './auth.service';
import { environment, IS_NEW_UI_FLOW } from '../../environments/environment';
import { da } from 'date-fns/locale';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-auth',
    templateUrl: './auth.component.html',
    styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit, OnDestroy {
    @ViewChild('content') content!: IonContent;
    @Input({ required: false }) isLoginModal = false;

    login = true;
    signup = false;
    verify = false;
    forgotPassword = false;
    countryCode = '';
    phone = '';
    isModal = false;

    isBottom = false;
    isNewUIFlow = IS_NEW_UI_FLOW;

    authStateSubscription = new Subscription();
    logo!: string;
    isDarkMode!: boolean;
    public production: boolean = environment.production;

    private readonly destroy$: Subject<void> = new Subject();

    constructor(
        private authService: AuthService,
        private modalController: ModalController,
        private menuCtrl: MenuController,
        private themeService: ThemeService,
        private navCtrl: NavController,
        private router: Router
    ) { }

    async ngOnInit() {
        this.authStateSubscription = this.authService.cast.subscribe((data) => {
            this.login = data.login;
            this.signup = data.signup;
            this.verify = data.verify;
            this.forgotPassword = data.forgotPassword;
            this.countryCode = data.country_code;
            this.phone = data.phone;
            this.modalController.dismiss({ data: 'login-success' });
        });

        if (await this.authService.isAuthenticated()) {
            this.router.navigate(['/'], { replaceUrl: true });
        }

        this.isDarkMode = this.themeService.isDarkMode;
        this.logo = this.isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';

        this.themeService
            .subscribeThemeUpdate()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (isDarkMode) => {
                    this.logo = isDarkMode ? '/assets/img/logo-60-darkmode.png' : '/assets/img/logo-60.png';
                }
            );
    }


    ngOnDestroy() {
        this.authStateSubscription.unsubscribe();
        this.destroy$.next();
        this.destroy$.complete();
    }

    ionViewDidEnter() {
        this.menuCtrl.enable(false);
    }

    ionViewDidLeave() {
        this.menuCtrl.enable(true);
    }

    doLogin() {
        this.login = true;
        this.signup = false;
        this.verify = false;
        this.forgotPassword = false;
    }

    doSignup() {
        this.login = false;
        this.signup = true;
        this.verify = false;
    }

    doVerify() {
        this.login = false;
        this.signup = false;
        this.verify = true;
    }

    doForgotPassword() {
        this.login = false;
        this.signup = false;
        this.forgotPassword = true;
    }

    scrollToBottom() {
        this.content.scrollToBottom(300);
        this.isBottom = true;
    }

    scrollToTop() {
        this.content.scrollToTop(300);
        this.isBottom = false;
    }

    close() {
        localStorage.removeItem('redirectAfterLogin');
        this.modalController.dismiss();
    }

    newLayout() {
        this.navCtrl.navigateRoot(`${IS_NEW_UI_FLOW ? 'auth' : 'login'}`);
    }
}
